import { useState } from 'react'

import { DataItem, navigateTo, Obj } from 'scrivito'

import { errorToast } from '@/Components/Toast'
import { getOverviewPageLink } from '@/utils/dataClassMap'

interface UseDataItemDeleteOptions {
  /**
   * Navigate to the entity's overview page after a successful delete. Only correct on a
   * detail page, where the deleted record *was* the page. On a list surface the row
   * disappears on its own because the table is `connect()`ed, and navigating would rebuild
   * the URL from scratch — dropping the `f_*` filters, `order` and `view` params that
   * `writeUrlParams` owns, and on the dashboard and search-results tables throwing the user
   * off the page entirely.
   */
  navigateToOverview?: boolean
}

export const useDataItemDelete = (
  dataItem: DataItem,
  { navigateToOverview = false }: UseDataItemDeleteOptions = {},
) => {
  const [isLoading, setIsLoading] = useState(false)

  const dataClassName = dataItem.dataClassName()!
  const overviewPage = getOverviewPageLink(dataClassName)

  const deleteDataItem = () => {
    setIsLoading(true)
    dataItem
      .delete()
      .then(() => {
        if (navigateToOverview) {
          navigateTo(() => Obj.getByPermalink(overviewPage))
        }
      })
      .catch((e) => errorToast(e))
      .finally(() => setIsLoading(false))
  }

  return { deleteDataItem, isLoading }
}
